<template>
    <div class="datav-layout">
        <div class="datav-top">
            <div class="toptitle">
                <h2><span>{{nowarea}}电子商务人才需求动态展示平台</span></h2>
                <p>National e-commerce talent demand dynamic display platform</p>
            </div>
            <div class="topimg"><img src="/assets/images/top.gif"></div>
<!--            <div class="m-selectbox">-->
<!--                <select name="" id="year" @change="getYear(year)"-->
<!--                        v-model="year">-->
<!--                    <option value="">年度</option>-->
<!--                    <option value="2018">2018年</option>-->
<!--                    <option value="2019">2019年</option>-->
<!--                    <option value="2020">2020年</option>-->
<!--                </select>-->
<!--                <select name="" id="quarter" style="margin-left:4px" @change="getQuarter(quarter)"-->
<!--                        v-model="quarter">-->
<!--                    <option value="">季度</option>-->
<!--                    <option value="1">第一季度</option>-->
<!--                    <option value="2">第二季度</option>-->
<!--                    <option value="3">第三季度</option>-->
<!--                    <option value="4">第四季度</option>-->
<!--                </select>-->

<!--            </div>-->
        </div>
        <div class="datav-main">
            <div class="datav-left">
                <h1 class="m-datatitle" style="margin-left:10px;padding-bottom:0px">各维度人才需求分析</h1>
                <div style="margin-left:20px;font-size:10px;color: #B1B1B1;padding-bottom:20px">Analysis of talent
                    demand in all dimensions
                </div>
                <div class="m-leftchartbox">
                    <div class="f-clear">
                        <div class="f-left" style="width:230px; height:180px;display:inline-block;margin-left:10px;">
                            <h3 class="m-lchartt" style="display:inline-block;margin-bottom:15px;width: 130px">
                                总需求量<br><strong>约<span>{{totalCnt}}</span>人</strong></h3>
                            <h3 class="m-lchartt" style="display:inline-block;">
                                平均薪资<br><strong>约<span>{{payAvg}}</span>元</strong></h3>
                            <h3 class="m-lchartt" style="display:inline-block;margin-bottom:15px;width: 130px;">
                                年度新增需求量<br><strong>约<span>{{newCnt}}</span>人</strong></h3>
                            <!--                            <h3 class="m-lchartt" style="display:inline-block;">-->
                            <!--                                岗位数量<br><strong>约<span>35</span>个</strong></h3>-->
                        </div>
                        <div class="m-leftchart1 f-left" style="width:340px; height:180px;display:inline-block;">
                            <div id="partOne" style="width:340px; height:180px; margin:0 auto"></div>
                        </div>
                        <div class="f-left" style="width:570px; height:180px;display:inline-block;margin-left:10px;">
                            <div class="monitor panel" style="height: 11.5rem;border-color: #061B26;">
                                <div class="inner">
                                    <div class="content" style="display: block;">
                                        <div class="head">
                                            <span class="col">TOP20热门行业</span>
                                            <span class="col">需求量</span>
                                            <span class="col">平均薪资</span>
                                        </div>
                                        <div class="marquee-view">
                                            <div class="marquee">
                                                <template v-for="(item, index) in cntPayavgGroupbyTop20Pro">
                                                    <div class="row" style="background:#061B26">
                                                        <span class="col">{{item.name}}</span>
                                                        <span class="col">{{item.cnt}}</span>
                                                        <span class="col">{{parseInt(item.payavg)}}</span>
                                                        <span class="icon-dot"></span>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="m-leftchart2 f-left"
                             style="width:280px; height:150px;display:inline-block;padding-top: 20px">
                            <div id="partTwo" style="width:280px; height:155px; margin:0 auto"></div>
                        </div>
                        <div class="m-leftchart3 f-left"
                             style="width:280px; height:155px;display:inline-block;padding-top: 20px">
                            <div id="partThree" style="width:280px; height:150px; margin:0 auto"></div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="datav-right" style="overflow:scroll;height:600px;">
                <template v-for="(item, index) in provincedatalist">
                    <dl class="m-rightchart f-clear" @click="changeCity(item)" style="cursor:pointer">
                        <dt>{{item.name}}人才需求</dt>
                        <dd>数量<span style="font-size:13px">{{item.cnt}}</span></dd>
                        <dd>平均薪资<span style="font-size:13px">{{parseInt(item.payavg)}}</span></dd>
                    </dl>
                </template>
            </div>
            <div class="datav-center" style="background:rgba(19, 63, 88,0.7)">
                <div style="width:720px;height:560px;margin:20px auto;" id="main"></div>
            </div>
        </div>
        <div class="datav-bottom">
            <div class="f-clear">
                <div class="m-blchartbox f-left">
                    <div class="m-blchart f-left">
                        <h2 class="m-datatitle">{{top4SortCnt[0].name}}</h2>
                        <div class="m-blchartinfo">总需求量<br><span>共<strong>{{top4SortCnt[0].value}}</strong>人</span>
                        </div>
                        <div id="bottomOne" style="width:95%; height:50px;"></div>
                    </div>
                    <div class="m-blchart f-left">
                        <h2 class="m-datatitle">{{top4SortCnt[1].name}}</h2>
                        <div class="m-blchartinfo">总需求量<br><span>共<strong>{{top4SortCnt[1].value}}</strong>人</span>
                        </div>
                        <div id="bottomTwo" style="width:95%; height:50px;"></div>
                    </div>
                    <div class="m-blchart f-left">
                        <h2 class="m-datatitle">{{top4SortCnt[2].name}}</h2>
                        <div class="m-blchartinfo">总需求量<br><span>共<strong>{{top4SortCnt[2].value}}</strong>人</span>
                        </div>
                        <div id="bottomThree" style="width:95%; height:50px;"></div>
                    </div>
                    <div class="m-blchart f-left">
                        <h2 class="m-datatitle">{{top4SortCnt[3].name}}</h2>
                        <div class="m-blchartinfo">总需求量<br><span>共<strong>{{top4SortCnt[3].value}}</strong>人</span>
                        </div>
                        <div id="bottomFour" style="width:95%; height:50px;"></div>
                    </div>
                    <!--<div class="m-blchart f-left" style="width:300px; height:150px;display:inline-block;padding-top: 20px">
                        <div id="bottomFive" style="width:95%; height:50px;"></div>
                    </div>-->
                </div>
                <div class="m-brchartbox f-right" style="background:#0A1012;">
                    <div class="m-brchart1 f-left">
                        <div id="bottomFive" style="width:100%; height:150px;"></div>
                    </div>
                    <div class="m-brchart2 f-right" style="padding-top: 10px">
                        <div id="bottomSix" style="width:100%; height:150px;"></div>
                    </div>
                </div>
            </div>
        </div>
        <popuper ref="popuper"></popuper>
        <loginer ref="loginer"></loginer>
    </div>
</template>

<script>
    import Popuper from "../popuper";
    import Loginer from "../loginer";
    export default {
        name: "dsdatavisual",
        components: {Popuper,Loginer},
        data() {
            return {
                totalCnt: '',
                payAvg: '',
                newCnt: '',
                province: '',
                city: '',
                year: '2020',
                quarter: '',
                nowarea: '全国',
                nowareatype: 1,
                provincedatalist: [],
                //tip20行业
                cntPayavgGroupbyTop20Pro: [],
                top4SortCnt: [{name: '', value: ''}, {name: '', value: ''}, {name: '', value: ''}, {
                    name: '',
                    value: ''
                }],
                echarts4data: []

            };
        },
        computed:{
            datamem(){
                return this.$store.state.user.datamem;
            },
            useraccount(){
                return this.$store.state.user.useraccount;
            },
        },
        watch: {
            province: 'init' // 值可以为methods的方法名
        },
        created() {
            this.init();
        },
        methods: {
            popup(e) {
                let option={
                    type:e
                };
                this.$refs.popuper.show(option);
            },
            getYear(year) {
                if(this.useraccount){
                    if (year) {
                        if(this.datamem){
                            this.year = year;
                            this.init();
                        }else{
                            this.popup(3);
                        }
                    }
                }else{
                    this.$refs.loginer.show();
                }

            },
            getQuarter(quarter) {
                if (this.useraccount) {
                    if (quarter) {
                        if (this.datamem) {
                            this.quarter = quarter;
                            this.init();
                        } else {
                            this.popup(3);
                        }

                    }
                } else {
                    this.$refs.loginer.show();
                }
            },
            changeCity(item) {
                // if (this.useraccount) {
                // if(item){
                //     if(this.datamem){
                //         if (this.nowareatype === 2) {
                //             this.city = item.name;
                //             // this.province = '';
                //         } else {
                //             this.nowareatype = 2;
                //             this.province = item.name;
                //             this.city = '';
                //         }
                //         this.nowarea = item.name;
                //         this.init();
                //     }else{
                //         this.popup(3);
                //     }
                // }
                // } else {
                //     this.$refs.loginer.show();
                // }
            },
            // checkurl(url) {
            //     if (url.indexOf('?') !== -1) {
            //         return url = url + "&"
            //     } else {
            //         return url = url + "?"
            //     }
            // },
            async init() {//初始化
                let that = this;
                let url = '/jobs/eb/all';
                const param = {sorttype:1};
                if (that.province) {
                    param.province=that.province;
                    // url = that.checkurl(url) + 'province=' + that.province
                }
                if (that.city) {
                    param.city=that.city;
                    // url = that.checkurl(url) + 'city=' + that.city
                }
                if (that.year) {
                    param.year=that.year;
                    // url = that.checkurl(url) + 'year=' + that.year
                }
                if (that.quarter) {
                    if (that.quarter === '1') {
                        param.starttime="01-01";
                        param.endtime="03-31";
                        // url = that.checkurl(url) + 'starttime=&endtime=03-31'
                    } else if (that.quarter === '2') {
                        param.starttime="04-01";
                        param.endtime="06-30";
                        // url = that.checkurl(url) + 'starttime=04-01&endtime=06-30'
                    } else if (that.quarter === '3') {
                        param.starttime="07-01";
                        param.endtime="09-30";
                        // url = that.checkurl(url) + 'starttime=07-01&endtime=09-30'
                    } else if (that.quarter === '4') {
                        param.starttime="10-01";
                        param.endtime="12-31";
                        // url = that.checkurl(url) + 'starttime=10-01&endtime=12-31'
                    }
                }
                let record = await this.ajax.getJson(url, param);
                // console.log(record);
                that.provincedatalist = record.cntPayavgGroupbyProvinceOrCity;
                that.cntPayavgGroupbyTop20Pro = record.cntPayavgGroupbyTop20Pro;
                that.totalCnt = record.totalCnt;
                // that.usertype = this.$store.state.user.usertype;
                that.payAvg = parseInt(record.payAvg);
                that.newCnt = parseInt(record.newCnt);

                //按月统计需求量和平均薪资
                let echarts1cntdata = [];
                let echarts1paydata = [];
                let echarts1namedata = [];
                $.each(record.cntPayavgGroupbyMonth, function (i, v) {
                    echarts1cntdata.push(v.cnt);
                    echarts1paydata.push(parseInt(v.payavg));
                    echarts1namedata.push(v.name.substring(4, 6));
                });
                let echarts1lymax = Math.max.apply(null, echarts1cntdata);
                let echarts1rymax = Math.max.apply(null, echarts1paydata);
                // console.log(option);
                let myChart = echarts.init(document.getElementById('partOne'));
                option.title.text = "月份需求及平均薪资趋势统计图";
                option.series[0].data = echarts1cntdata;
                option.series[1].data = echarts1paydata;
                option.xAxis[0].data = echarts1namedata;
                option.yAxis[0].max = echarts1lymax;
                option.yAxis[0].interval = Math.ceil(echarts1lymax / 4);
                option.yAxis[1].max = echarts1rymax;
                option.yAxis[1].daintervalta = Math.ceil(echarts1rymax / 4);
                myChart.hideLoading();
                myChart.setOption(option);


                //各工作经验需求量及平均薪资
                let echarts2cntdata = [];
                let echarts2paydata = [];
                let echarts2namedata = [];
                $.each(record.cntPayavgGroupbyExp, function (a, b) {
                    echarts2cntdata.push(b.cnt);
                    echarts2paydata.push(parseInt(b.payavg));
                    if (b.name === 0) {
                        echarts2namedata.push("应届生");
                    } else {
                        echarts2namedata.push(b.name + '年');
                    }

                });
                let echarts2lymax = Math.max.apply(null, echarts2cntdata);
                let echarts2rymax = Math.max.apply(null, echarts2paydata);
                // console.log(option);
                let myChart1 = echarts.init(document.getElementById('partTwo'));
                option.title.text = "各工作经验需求量及平均薪资";
                option.series[0].data = echarts2cntdata;
                option.series[1].data = echarts2paydata;
                option.xAxis[0].data = echarts2namedata;
                option.yAxis[0].max = echarts2lymax;
                option.yAxis[0].interval = Math.ceil(echarts2lymax / 4);
                option.yAxis[1].max = echarts2rymax;
                option.yAxis[1].daintervalta = Math.ceil(echarts2rymax / 4);
                myChart1.hideLoading();
                myChart1.setOption(option);

                //学历需求占比
                let echarts4cntdata = [];
                $.each(record.cntPayavgGroupbyEdu, function (a, b) {
                    let echarts4data = {
                        value: b.cnt,
                        name: b.name
                    };
                    console.log(echarts4data);
                    echarts4cntdata.push(echarts4data);
                });
                that.echarts4data = echarts4cntdata;
                console.log(that.echarts4data);
                let myChart3 = echarts.init(document.getElementById('partThree'));
                let option3 = {
                    color: ['#055f78', '#66CCFF', '#CC6666', '#ff7d37', '#FFCC33', '#0099CC', '#00f2f1', '#01989b'],
                    tooltip: {},
                    toolbox: {},
                    grid: {
                        left: '10%',
                        right: '0%',
                        top: '25%',
                        bottom: '10%',
                        containLabel: true
                    },
                    series: [
                        {
                            name: '需求量',
                            type: 'pie',
                            radius: [15, 65],
                            roseType: 'radius',
                            label: {        //展示文本设置
                                normal: {
                                    show: true,     //文本展示
                                    position: 'outside',      // outside表示文本显示位置为外部
                                    // textStyle: {
                                    //     color: 'red'  // 改变标示文字的颜色
                                    // }
                                },
                                emphasis: {    //文本样式
                                    show: false,    //展示
                                    textStyle: {    //文本样式
                                        fontSize: '14',
                                        fontWeight: '600',
                                    }
                                }
                            },
                            labelLine: {    //引导线设置
                                normal: {
                                    show: true,   //引导线显示
                                    length: 3,  // 改变标示线的长度
                                }
                            },
                            data: that.echarts4data
                        }
                    ]
                };
                myChart3.setOption(option3);

                //top4岗位以及12个月需求量以及平均薪资
                let myChart6 = echarts.init(document.getElementById('bottomOne'));
                let myChart7 = echarts.init(document.getElementById('bottomTwo'));
                let myChart8 = echarts.init(document.getElementById('bottomThree'));
                let myChart9 = echarts.init(document.getElementById('bottomFour'));
                that.top4SortCnt = record.top4SortCnt;
                $.each(record.jobsort1CountPayavgGroupbyMonth, function (i, v) {
                    let buttom1cntdata = [];
                    let buttom1paydata = [];
                    let buttom1namedata = [];
                    $.each(v.month, function (a, b) {
                        buttom1cntdata.push(b.cnt);
                        buttom1paydata.push(parseInt(b.payavg));
                        buttom1namedata.push(b.name.substring(4, 6));
                    });
                    let buttom1lymax = Math.max.apply(null, buttom1cntdata);
                    let buttom1rymax = Math.max.apply(null, buttom1paydata);
                    option6.series[0].data = buttom1cntdata;
                    option6.series[1].data = buttom1paydata;
                    option6.xAxis[0].data = buttom1namedata;
                    option6.yAxis[0].max = buttom1lymax;
                    option6.yAxis[0].interval = Math.ceil(buttom1lymax / 4);
                    option6.yAxis[1].max = buttom1rymax;
                    option6.yAxis[1].daintervalta = Math.ceil(buttom1rymax / 4);
                    if (i === 0) {
                        myChart6.hideLoading();
                        myChart6.setOption(option6);
                    } else if (i === 1) {
                        myChart7.hideLoading();
                        myChart7.setOption(option6);
                    } else if (i === 2) {
                        myChart8.hideLoading();
                        myChart8.setOption(option6);
                    } else if (i === 3) {
                        myChart9.hideLoading();
                        myChart9.setOption(option6);
                    }

                });
                //五大岗位群以及12个月需求量以及平均薪资
                let myChart10 = echarts.init(document.getElementById('bottomFive'));
                let datayygl = [];
                let datayxtg = [];
                let datasjsj = [];
                let datagylgl = [];
                let datakhyy = [];
                $.each(record.jobsort1CountPayavgGroupbyMonth, function (a, b) {
                    let vdata = [];
                    if (b.name === "运营管理") {
                        $.each(b.month, function (i, v) {
                            vdata = [];
                            vdata.push(i+1);
                            vdata.push(parseInt(v.payavg));
                            vdata.push(4);
                            datayygl.push(vdata);
                        });
                        console.log(datayygl);
                    } else if (b.name === "营销推广") {
                        $.each(b.month, function (i, v) {
                            vdata = [];
                            vdata.push(i+1);
                            vdata.push(parseInt(v.payavg));
                            vdata.push(4);
                            datayxtg.push(vdata);
                        });
                    } else if (b.name === "视觉设计") {
                        $.each(b.month, function (i, v) {
                            vdata = [];
                            vdata.push(i+1);
                            vdata.push(parseInt(v.payavg));
                            vdata.push(4);
                            datasjsj.push(vdata);
                        });
                    } else if (b.name === "供应链管理") {
                        $.each(b.month, function (i, v) {
                            vdata = [];
                            vdata.push(i+1);
                            vdata.push(parseInt(v.payavg));
                            vdata.push(4);
                            datagylgl.push(vdata);
                        });
                    } else if (b.name === "客户运营") {
                        $.each(b.month, function (i, v) {
                            vdata = [];
                            vdata.push(i+1);
                            vdata.push(parseInt(v.payavg));
                            vdata.push(4);
                            datakhyy.push(vdata);
                        });
                    }

                });
                let itemStyle = {
                    opacity: 0.8,
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                };

                let option10 = {
                    //backgroundColor: '#404a59',
                    color: [
                        '#f0e4d7', '#f5c0c0', '#ff7171', '#9fd8df', '#ffe268'
                    ],
                    title: {
                        left: 'center',
                        //top: '-2',
                        text: '五大岗位群各月平均薪资趋势统计',
                        textStyle: {
                            fontSize: 10,
                            color: '#c6cfd7',
                            fontWeight: 'normal'
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '10%',
                        top: '20%',
                        bottom: '0%',
                        containLabel: true
                    },
                    tooltip: {
                        padding: 10,
                        backgroundColor: '#222',
                        borderColor: '#777',
                        borderWidth: 1,
                            /*返回需要的信息*/
                            formatter: function(obj) {
                                let value = obj.value;
                                return obj.seriesName+ '<br>'+
                                '平均薪资：' + value[1] + '<br>';
                            }
                    },
                    xAxis: {
                        type: 'value',
                        name: '月',
                        nameGap: 16,
                        nameTextStyle: {
                            color: '#B1B1B1',
                            fontSize: 8
                        },
                        max: 12,
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                width: 0.5,
                                color: '#B1B1B1'
                            }
                        },
                        axisLabel: {
                            //rotate: 60,
                            textStyle: {
                                fontSize: 8,
                                color: '#B1B1B1'
                            },
                        }
                    },
                    yAxis: {
                        type: 'value',
                        name: '平均薪资/元',
                        nameLocation: 'end',
                        nameGap: 10,
                        nameTextStyle: {
                            color: '#B1B1B1',
                            fontSize: 8
                        },
                        axisLine: {
                            lineStyle: {
                                width: 0.5,
                                color: '#B1B1B1'
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            formatter: '{value}',
                            textStyle: {
                                fontSize: 8,
                                color: '#B1B1B1'
                            }
                        },
                    },
                    visualMap: [
                        {
                            left: 'right',
                            top: '10%',
                            dimension: 2,//指定用数据的『哪个维度』，映射到视觉元素上。
                            min: 0,
                            max: 250,
                            show: false,
                            precision: 0.1,//展式的小数点精度
                            textStyle: {
                                color: '#fff'
                            },
                            inRange: {
                                symbolSize: [10, 70]
                            },
                        },

                    ],
                    series: [
                        {
                            name: '运营管理',
                            type: 'scatter',
                            itemStyle: itemStyle,
                            //color: '#019a9b',
                            data: datayygl
                        },
                        {
                            name: '营销推广',
                            type: 'scatter',
                            itemStyle: itemStyle,
                            data: datayxtg
                        },
                        {
                            name: '视觉设计',
                            type: 'scatter',
                            itemStyle: itemStyle,
                            data: datasjsj
                        },
                        {
                            name: '供应链管理',
                            type: 'scatter',
                            itemStyle: itemStyle,
                            data: datagylgl
                        },
                        {
                            name: '客户运营',
                            type: 'scatter',
                            itemStyle: itemStyle,
                            data: datakhyy
                        }
                    ]
                };
                myChart10.setOption(option10);

                let citydata = [];
                let indicatordata = [];
                let cityname = '全国';
                $.each(record.cntPayavgByJobsort1, function (a, b) {
                    let indicator ={
                        name:b.name,
                        max:b.cnt*1.2,
                    };
                    indicatordata.push(indicator);
                    citydata.push(b.cnt);
                });

                let myChart11 = echarts.init(document.getElementById('bottomSix'));
                console.log(option11);
                option11.radar.indicator = indicatordata;
                // option11.series[0].data[0].value = countrydata;
                option11.series[0].data[0].value = citydata;
                if(that.city){
                    cityname = that.city;
                }else if(!that.city&&that.province){
                    cityname = that.province;
                }
                option11.series[0].data[0].name = cityname;
                myChart11.hideLoading();
                myChart11.setOption(option11);

                //地图
                $.each(record.cntPayavgGroupbyProvince,function (i,v) {
                    $.each(BJData,function (a,b) {
                        if(v.name===b[1].name){
                            b[1].value=v.cnt;
                        }
                    });
                    $.each(SHData,function (a,b) {
                        if(v.name===b[1].name){
                            b[1].value=v.cnt;
                        }
                    });
                    $.each(GZData,function (a,b) {
                        if(v.name===b[1].name){
                            b[1].value=v.cnt;
                        }
                    });
                });
                let series = [];
                [
                    ['东部', BJData],
                    ['中部', SHData],
                    ['西部', GZData]
                ].forEach(function (item, i) {
                    series.push({
                        name: item[0],
                        type: 'lines',
                        zlevel: 1,
                        effect: {
                            show: true,
                            period: 6,
                            trailLength: 0.7,
                            color: '#fff',
                            symbolSize: 3
                        },
                        lineStyle: {
                            normal: {
                                color: color[i],
                                width: 0,
                                curveness: 0.2
                            }
                        },
                        data: convertData(item[1])
                    }, {
                        name: item[0],
                        type: 'lines',
                        zlevel: 2,
                        effect: {
                            show: true,
                            period: 6,
                            trailLength: 0,
                            symbol: planePath,
                            symbolSize: 15
                        },
                        lineStyle: {
                            normal: {
                                color: color[i],
                                width: 1,
                                opacity: 0.4,
                                curveness: 0.2
                            }
                        },
                        data: convertData(item[1])
                    }, {
                        name: item[0],
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        zlevel: 2,
                        rippleEffect: {
                            brushType: 'stroke'
                        },
                        label: {
                            normal: {
                                // show: true,
                                position: 'right',
                                formatter: '{b}'
                            },
                            emphasis: {
                                show: true
                            }
                        },
                        symbolSize: function (val) {
                            let v = val[2];
                            let r;
                            if (v >= 300000) {
                                r = 25;
                            } else if (v >= 36000) {
                                r = 15;
                                // r = 20 + Math.sqrt(v - 36000) / 16;
                            } else if (v >= 6000) {
                                r = 10;
                                // r = 13 + Math.sqrt(v - 464) / 8;
                            } else {
                                r = 5;
                                // r = 13 - (464 - v) / 58;
                            }
                            return r;
                        },
                        itemStyle: {
                            normal: {
                                color: color[i]
                            }
                        },
                        data: item[1].map(function (dataItem) {
                            return {
                                name: dataItem[1].name,
                                value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
                            };

                        })
                    });
                });
                let myecharts = echarts.init(document.getElementById('main'));
                optionmap.series = series;
                myecharts.hideLoading();
                myecharts.setOption(optionmap);
                // myecharts.on('click', function (params) {
                //     if(that.useraccount){
                //         if(that.datamem){
                //             that.nowareatype = 2;
                //             that.nowarea = params.name;
                //             that.province = params.name;
                //             that.city = '';
                //         }else{
                //             that.popup(3);
                //         }
                //     }else{
                //         that.$refs.loginer.show();
                //     }
                //
                // });
            },
        }
    };
</script>
